import { render, staticRenderFns } from "./SubtopicFooter.vue?vue&type=template&id=63aaf64d&scoped=true&"
import script from "./SubtopicFooter.vue?vue&type=script&lang=js&"
export * from "./SubtopicFooter.vue?vue&type=script&lang=js&"
import style0 from "./SubtopicFooter.vue?vue&type=style&index=0&id=63aaf64d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aaf64d",
  null
  
)

export default component.exports